import { AxiosError } from 'axios';

export type NetworkError =
  | 'unauthorized'
  | 'forbidden'
  | 'resource_conflict'
  | 'resource_not_found'
  | 'client_error'
  | 'server_error'
  | 'unknown';

export const getErrorDetails = (error: AxiosError): NetworkErrorDetails => {
  if (!error.response)
    return {
      type: 'unknown',
      message: 'An unknown error occurred. Contact a system administrator for more information.',
      code: error.code,
    };

  return {
    type: getNetworkError(error),
    message: error.response.data.Message,
  };
};

export const getNetworkError = (error: any): NetworkError => {
  if (!error.response) {
    return 'unknown';
  }

  const status = error.response.status;

  if (status === 401) {
    return 'unauthorized';
  }
  if (status === 403) {
    return 'forbidden';
  }
  if (status === 404) {
    return 'resource_not_found';
  }
  if (status === 409) {
    return 'resource_conflict';
  }
  if (status >= 400 && status < 500) {
    return 'client_error';
  }
  if (status >= 500 && status < 600) {
    return 'server_error';
  }
  return 'unknown';
};

export type ShiftLogDetailError = {
  type: ShiftLogDetailErrorType | NetworkError;
  message: string;
};

export type NetworkErrorDetails = {
  type: NetworkError;
  message: string;
  code?: string;
};

export type ShiftLogDetailErrorType = 'save_failure' | 'submit_failure' | 'takeover_failure';
